import styles from '../markers.module.scss';
import {
  AssetInvestigationType,
  InvestigationAssetType,
} from '@customer/store/apis/investigationsApi';
import { Tooltip } from 'react-leaflet';
import RotatableMarker from '../rotatable-marker/RotatableMarker';
import {
  IconArrowBlack,
  IconArrowBlue,
  IconArrowGray,
  IconCircleBlack,
  IconCircleBlue,
  IconCircleGray,
} from '../icons';
import { Icon, LatLngExpression } from 'leaflet';
import { useTranslation } from 'react-i18next';
import { CustomPaneName } from '../../mapConfig';

// Initialise the icon layers to avoid re-creating them on every render or prop change.
const InvestigationMapIcons: Record<InvestigationAssetType, [Icon, Icon]> = {
  [InvestigationAssetType.Local]: [new IconArrowBlack(), new IconCircleBlack()],
  [InvestigationAssetType.Remote]: [new IconArrowBlue(), new IconCircleBlue()],
  [InvestigationAssetType.Nearby]: [new IconArrowGray(), new IconCircleGray()],
};

export const AssetTypeName: Record<InvestigationAssetType, string> = {
  [InvestigationAssetType.Local]: 'LO',
  [InvestigationAssetType.Remote]: 'RO',
  [InvestigationAssetType.Nearby]: 'investigationAssetType.Nearby',
};

export interface InvestigationAssetMarkerProps {
  name: string;
  position: LatLngExpression;
  heading: number | null;
  type: InvestigationAssetType;
  pane?: CustomPaneName;
  investigationType?: AssetInvestigationType;
}

export const InvestigationAssetMarker = ({
  name,
  position,
  heading,
  type,
  pane,
  investigationType,
}: InvestigationAssetMarkerProps) => {
  const { t } = useTranslation(undefined, { useSuspense: false });

  // Use the asset type to get either the arrow or circle icon in the relevant color from the already initialised icons.
  const icon = InvestigationMapIcons[type][heading !== null ? 0 : 1];
  const objectType = AssetTypeName[type];
  const isCustom = investigationType === AssetInvestigationType.Custom;

  return (
    <RotatableMarker position={position} heading={heading} icon={icon} pane={pane}>
      <Tooltip className="tooltip-override" offset={[0, 0]}>
        <div className={styles.popup}>
          {!isCustom && <span>{t(objectType)}</span>}
          <span className={`${isCustom ? styles['popup__name--compact'] : styles['popup__name']}`}>
            {name}
          </span>
        </div>
      </Tooltip>
    </RotatableMarker>
  );
};
